import React, { useEffect, useState } from "react";
import Step1 from "./Step1";
import Step2 from "./Step2";
import { useParams } from "react-router-dom";
import BasicTenderInfo from "../../Users/BriefTender/BasicTenderInfo";
import axios from "axios";
import { Typography } from "@mui/material";
import PreviewDetails from "./PreviewDetails";

const QualificationDetails = () => {
  const [step, setStep] = useState(1);
  const [tender, setTender] = useState();
  const [qDetails, setQDetails] = useState();
  const [workItems, setWorkItems] = useState();
  const storedUser = JSON.parse(localStorage.getItem("user"));
  const vendorId = JSON.parse(localStorage.getItem("vendor"));
  const { tenderId } = useParams();
  const form = localStorage.getItem("form");
  const [fileNames, setFileNames] = useState({
    businessRegistration: "",
    businessLicense: "",
    insurance: "",
    compliance: "",
    bankAccount: "",
    clientReference: "",
    performanceHistory: "",
    certifications: "",
    dataProtection: "",
    securityMeasures: "",
    financialStatements: "",
    bankStatements: "",
    others: "",
  });
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    const getTender = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/tender/get-by-id?tenderId=${tenderId}`,
          { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
        );
        setTender(res.data);
        setWorkItems(res.data.workItemDetails);
      } catch (error) {
        console.error("Error updating tender status:", error);
      }
    };
    getTender();
  }, []);

  useEffect(() => {
    if (form === "IMPORT") {
      const getQDetails = async () => {
        setLoading(true)
        try {
          const res = await axios.get(
            `${process.env.REACT_APP_BACKEND_URL}/vtq/get-details?vendorId=${vendorId}`,
            { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
          );
          setQDetails(res.data);
          setFileNames({
            businessRegistration: res.data.businessRegistrationFilename || "",
            businessLicense: res.data.businessLicenseFilename || "",
            insurance: res.data.insuranceFilename || "",
            compliance: res.data.complianceFilename || "",
            bankAccount: res.data.bankAccountFilename || "",
            clientReference: res.data.clientReferenceFilename || "",
            performanceHistory: res.data.performanceHistoryFilename || "",
            certifications: res.data.certificationsFilename || "",
            dataProtection: res.data.dataProtectionFilename || "",
            securityMeasures: res.data.securityMeasuresFilename || "",
            financialStatements: res.data.financialStatementsFilename || "",
            bankStatements: res.data.bankStatementsFilename || "",
            others: res.data.othersFilename || "",
          });          
        } catch (error) {
          console.error("Error updating tender status:", error);
        } finally {
          setLoading(false)
        }
      };
      getQDetails();
    }
  }, []);

  return (
    <div style={{position: 'relative'}}>
      {loading && <div className="loading-div">Fetching Data...</div> }
      {step === 1 && (
        <>
          <BasicTenderInfo tender={tender} />
          <Typography variant="h4">Vendor Qualification</Typography>
          <Step1
            tender={tender}
            qDetails={qDetails}
            setQDetails={setQDetails}
            setStep={setStep}
            storedUser={storedUser}
            fileNames={fileNames}
            setFileNames={setFileNames}
          />
        </>
      )}
      {step === 2 && (
        <>
          <BasicTenderInfo tender={tender} />
          <Typography variant="h4">Vendor Qualification</Typography>
          <Step2
            tender={tender}
            qDetails={qDetails}
            setQDetails={setQDetails}
            setStep={setStep}
            storedUser={storedUser}
            fileNames={fileNames}
            setFileNames={setFileNames}
          />
        </>
      )}
      {step === 3 && (
        <PreviewDetails
          qDetails={qDetails}
          setStep={setStep}
          storedUser={storedUser}
          fileNames={fileNames}
        />
      )}
    </div>
  );
};

export default QualificationDetails;
